module.exports = __webpack_public_path__ + "assets/merriweather-bolditalic.27c7f18fc9e4029871084a6a2a4f12022a740049b7808734132413c56b21e44f.woff";